import React from 'react';
import ProductCard from './ProductCard';
import { getProducts } from '../../utils/productStore';
import './Products.scss';

const Products = () => (
  <section className="products-section" id="materialHandling">
    <div className="container">
      <div className="section-header">
        <span className="badge-label">Our Products</span>
        <h2>Aerial Lifts, Scissor Lifts, Goods Lifts &amp; More</h2>
        <div className="section-divider" />
        <p>
          Explore our aerial lifts, scissor lifts, goods lifts, stackers, pallet trucks
          and other material handling equipment. Click any product for specifications
          and a quote.
        </p>
      </div>

      <div className="row g-4">
        {getProducts().map((product) => (
          <div key={product.id} className="col-sm-6 col-lg-3">
            <ProductCard product={product} />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Products;

